// routes/_embedded.embedded.chat-editing.workspace.$workspaceId.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_embedded.embedded.chat-editing.workspace.$workspaceId')

export const handle = { name: 'embedded-chat-editing-workspace' }

export default dynamic(getClientModule, { ssr: false })
